export class ReferralSourceModel {
    public id: number;
    public name: string;
    public description: string;
}
